import RatingComponent from './RatingComponent';
import { Box, Button, Card, CardActions, CardContent, CardHeader, CardMedia, Modal, Typography, styled } from '@mui/material';
import { useState } from 'react';
import MenuProperty from '../navigation/desktop/MenuProperty';
import FichaPropertyDialog from './FichaPropertyDialog';
import PropertyDetailView from '../../pages/PropertydetailView';
import { useNavigate } from 'react-router-dom';

// Componentes estilizados - Versión ampliada
const StyledCard = styled(Card)(({ theme }) => ({
  width: '100%',
  minWidth: 300,    //350,
//   height: '100%',
  minHeight: 400,   //500,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: "#f8f9f9",
  marginBottom: theme.spacing(2),
  position: 'relative',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: theme.shadows[6]
  }
}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  flexGrow: 1,
  lineHeight: '1.6em',
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(3),
}));

const StyledCardMedia = styled(CardMedia)({
  height: 250, // Altura fija más grande
  width: '100%',
  objectFit: 'cover',
  cursor: 'pointer'
});

const ExpandButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  fontWeight: 'bold'
}));

const PropertyCard = ({ data, expanded }) => {
    const navigate = useNavigate();
    const [openDetailView, setOpenDetailView] = useState(false);
    const [dataItem, setDataItem] = useState(data);
    const [dataItemRating, setDataItemRating] = useState({
        promedio: data.ratingPromedio,
        cantidadRegistros: data.cantidadRegistros,
    });

    const imagenDefault = "https://firebasestorage.googleapis.com/v0/b/ecommerce-a78e2.appspot.com/o/images%2Fmixer-default.jpg?alt=media&token=1d0f686e-4c1d-41eb-a247-a75983439815";
    
    const verEvento = async (item) => {
        // history.push("/propertyEdit" + item.propertyId);
        console.log('item: ',item);
        navigate(`/propertyEdit/${item.id}`);
    };
    
    const handlePurchaseSuccess = (updatedProperty) => {
        // Actualiza el estado en el componente padre
        setDataItem(updatedProperty);
        
        // Si es necesario, actualiza también la lista de propiedades
        // setProperties(prev => prev.map(p => p.id === updatedProperty.id ? updatedProperty : p));
    };

    const [openDialog, setOpenDialog] = useState(false);
    const handleCloseDialog = () => {
        setOpenDialog(false);
    };
    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleDataUpdate = (newData) => {
        setDataItemRating(newData);
    };

    const handleOpenDetailView = () => {
        setOpenDetailView(true);
    };
    
    const handleCloseDetailView = () => {
        setOpenDetailView(false);
    };

    return (
        <>
            <StyledCard elevation={4}>
                <CardHeader
                    action={<MenuProperty verEvento={verEvento} dataItem={dataItem} handleDataUpdate={handleDataUpdate}/>}
                    title={
                        <Typography 
                            variant='body2' 
                            sx={{ 
                                fontWeight: 700,
                                minHeight: '3em',
                                display: 'flex',
                                color: "#2c3e50",
                                mb: 1.5,
                                fontSize: '1.2rem'
                            }}
                        >
                            {data.evento || data.name}
                        </Typography>
                    }
                    subheader={
                        <Typography variant='subtitle2' color="text.secondary">
                            Propietario: {dataItem.ownerName && `${dataItem.ownerName}`}
                        </Typography>
                    }
                    sx={{ padding: 3 }}
                />
                
                <StyledCardMedia
                    image={data.imageUrls?.length > 0 ? data.imageUrls[0] : imagenDefault}
                    title={`${data.name || data.evento}`}
                    onClick={handleOpenDialog}
                    onError={(e) => {
                        e.target.src = imagenDefault; // Fallback si la URL está rota
                    }}
                />
                
                <FichaPropertyDialog open={openDialog} handleClose={handleCloseDialog} data={data} />
                
                <StyledCardContent>
                    <Typography variant="body1" color="text.secondary" component="div" sx={{ mb: 2 }}>
                        {data.address && `${data.address}`}
                        {/* {expanded ? data.descripcion || 'Descripción no disponible' : `${data.name.substring(0, 100)}...`} */}
                    </Typography>
                    
                    <Typography variant="h6" color="primary" sx={{ mt: 'auto', fontWeight: 'bold' }}>
                        Precio: ${data.price?.toLocaleString() || 'N/A'}
                    </Typography>
                </StyledCardContent>
                
                <CardActions disableSpacing sx={{ padding: 3, paddingTop: 0 }}>
                    <RatingComponent 
                        value={data.ratingPromedio} 
                        cantidad={data.cantidadRegistros}  
                        dataItem={dataItemRating} 
                        handleDataUpdate={handleDataUpdate}
                        sx={{ fontSize: '1.2rem' }}
                    />
                    <ExpandButton 
                        onClick={handleOpenDetailView}
                        variant="contained"
                        size="small"
                        color="primary"
                    >
                        {expanded ? "Ver menos" : "Ver más"}
                    </ExpandButton>
                </CardActions>
            </StyledCard>
            {/* Modal con vista detallada */}
            <Modal open={openDetailView} onClose={handleCloseDetailView}>
                <PropertyDetailView 
                property={data} 
                onClose={handleCloseDetailView} 
                onPurchaseSuccess={handlePurchaseSuccess}
                />
            </Modal>
        </>
    );
};

export default PropertyCard;